import { render, staticRenderFns } from "./CreateAccountWindow.vue?vue&type=template&id=21fe43ef&"
import script from "./CreateAccountWindow.vue?vue&type=script&lang=js&"
export * from "./CreateAccountWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports